import LazyImage from "@eisinc/MobiusOverrides/LazyImage/LazyImage";

export default LazyImage;
export * from "./LazyImage";
export * from "./LazyPicture";
